var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { baseApi } from "@madmedical/store";
const api = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getMe: build.query({
            query: () => "medical/me",
        }),
        getDoctor: build.query({
            query: (id) => `medical/doctors/${id}`,
        }),
        getTreatingDoctors: build.query({
            query: (patientId) => `medical/patients/${patientId}/doctors`,
        }),
        getTreatedPatients: build.query({
            query: () => "medical/patients/treated",
        }),
        // TODO: Wrong types, either all forCallCenter or all forDoctor
        getPatients: build.query({
            query: (params) => ({
                url: `medical/patients`,
                params,
            }),
            serializeQueryArgs: ({ queryArgs }) => {
                const { page, pageSize } = queryArgs, args = __rest(queryArgs, ["page", "pageSize"]);
                return args;
            },
            merge: (cachedData, responseData) => {
                if (responseData.pagination.currentPage === 1) {
                    // Reset to first page
                    return responseData;
                }
                cachedData.items.push(...responseData.items);
                cachedData.pagination = responseData.pagination;
            },
            forceRefetch: ({ currentArg, previousArg }) => !currentArg ||
                !previousArg ||
                currentArg.page !== previousArg.page ||
                currentArg.pageSize !== previousArg.pageSize,
        }),
        getPatient: build.query({
            query: (id) => `medical/patients/${id}`,
        }),
        updatePatient: build.mutation({
            query: (_a) => {
                var { id } = _a, body = __rest(_a, ["id"]);
                return ({
                    url: `medical/patients/${id}`,
                    method: "PATCH",
                    body,
                });
            },
        }),
        getExternalUser: build.query({
            query: ({ integrator, externalId }) => `security/users/${integrator}/${externalId}`,
        }),
        getInstitutions: build.query({
            query: () => "medical/institutions",
        }),
        baseQuestionnaire: build.mutation({
            query: (_a) => {
                var { patientId } = _a, body = __rest(_a, ["patientId"]);
                return ({
                    url: `medical/patients/${patientId}/onboarding`,
                    method: "POST",
                    body,
                });
            },
        }),
        getUserPregnancyByPatient: build.query({
            query: ({ patientId }) => ({
                url: `medical/patients/${patientId}/pregnancies`,
            }),
        }),
    }),
});
export const { useGetMeQuery, useGetDoctorQuery, useGetTreatingDoctorsQuery, useGetTreatedPatientsQuery, useGetPatientsQuery, useGetPatientQuery, useGetExternalUserQuery, useLazyGetExternalUserQuery, useUpdatePatientMutation, useGetInstitutionsQuery, useBaseQuestionnaireMutation, useGetUserPregnancyByPatientQuery, } = api;
